import React from 'react'

const DropDownMenu = ({value,handlOnChange,disabled,options,placeholder}) => {
  return (
    <select
      value={value}
      onChange={handlOnChange}
      className="w-full h-12 px-4 text-sm font-medium text-gray-900 rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-200 focus-within:outline-0"
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default DropDownMenu
